import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

const useLayoutStore = create(
  immer((set, get) => {
    return {
      createdSignupResponse: null,
      setSingupResponse: (value) =>
        set(
          (state) => {
            state.createdSignupResponse = value;
          },
          false,
          "create-signupresponse/set-form-data"
        ),
      activeNav: "0",
      setActiveNav: (value) =>
        set(
          (state) => {
            state.activeNav = value;
          },
          false,
          "create-active-nav"
        ),
    };
  })
);

export default useLayoutStore;
